import style from "./HorizontalSeparetor.module.css"

export default function HorizontalSeparator({maxWidth, color}: {maxWidth: string, color?: string} ) {
    return <div style={{margin: "auto", width: "100%", maxWidth: maxWidth, height: "1px", background: color ? color : "#e2e2e2"}}></div>
}
